export const ID = 'e415c4e6-4dcc-41fc-b23b-e510239adfc8';

export const NAME = 'StorageMart Size Guide';
